namespace Interact {
	let finger: Tower;
	let armageddon: Tower;
	let atomic: Tower;
	let electric: Tower;
	let apoc: Tower;

	let armageddonBtn: Button;
	let atomicBtn: Button;
	let electroBtn: Button;
	let apocBtn: Button;

	let uiOpened: UIWindow;

	export let shopTower: TowerShop;
	export let shopRepair: RepairShop;

	export function showWnd(val: UIWindow) {
		if (uiOpened) {
			uiOpened.hide();
		}
		uiOpened = val;
	}

	export function hideWnd(val?: UIWindow) {
		if (val && val !== uiOpened) {
			return;
		}
		uiOpened = null;
	}

	export function init(): void {
		let world = Game.worldController;
		let dicts = Game.dicts;

		finger = new Tower(Assets.allTowers[1], dicts.finger);
		armageddon = new Tower(Assets.allTowers[1], dicts.armageddon);
		atomic = new Tower(Assets.allTowers[1], dicts.atomic);
		electric = new Tower(Assets.allTowers[1], dicts.electric);
		apoc = new Tower(Assets.allTowers[1], dicts.apocalypse);


		App.stage.on('pointerdown', (event: PIXI.interaction.InteractionEvent) => {
			if (uiOpened && uiOpened.visible) {
				uiOpened.hide();
				if (Tutorial.active) {
					Tutorial.prev();
				}
			}

			let p = new PIXI.Point();
			p.copy(event.data.global);
			//console.log("clicked at ("+p.x+" "+p.y+")");
			world.makeBoom(p.x, p.y, finger);
			Game.addBoomGraphics(p.x, p.y, finger.boomRadius);
		});

		document.addEventListener("keydown", handlerKeyDown);

		function handlerKeyDown(event: KeyboardEvent): void {
			if (event.keyCode == 65) { //a
				makeArmageddon();
			}
			if (event.keyCode == 83) { //s
				makeAtomic();
			}
			if (event.keyCode == 68) { //d
				makeElectric();
			}
			if (event.keyCode == 70) { //f
				makeApocalypse();
			}
		}

		initButtons();
		initWindows();

		initLighting();
	}

	export function makeArmageddon(): void {
		let world = Game.worldController;
		for (let i = 0; i < 500; i++) {
			setTimeout(() => {
				let x = (Math.random() * world.fieldPixelsWidth) | 0;
				let y = (Math.random() * world.fieldPixelsWidth) | 0;
				world.makeBoom(x, y, armageddon);
				Game.addBoomGraphics(x, y, armageddon.boomRadius);
			}, Math.random() * 1000);
		}
		armageddon.lastShot = Game.millisecondsAbsolute;
	}

	export function makeAtomic(): void {
		let world = Game.worldController;
		for (let i = 0; i < 30; i++) {
			setTimeout(() => {
				let x = (150 + Math.random() * 350) | 0;
				let y = (150 + Math.random() * 350) | 0;
				world.makeBoom(x, y, atomic);
				Game.addBoomGraphics(x, y, atomic.boomRadius);
			}, Math.random() * 10000);
		}
		atomic.lastShot = Game.millisecondsAbsolute;
		Game.makeElectricEffect();
	}

	export function makeApocalypse() {
		Game.makeWHATeffect();
	}

	export function makeElectric() {
		Game.worldController.makeElectrickShot(electric);
		lightingTime = 32.0;

		electric.lastShot = Game.millisecondsAbsolute;
	}

	function makeButton(tex: PIXI.Texture, x: number): Button {
		let screen = App.stage;

		let btn = new Button(tex);
		btn.position.set(x, 675);
		btn.setEnabled(false);
		screen.addChild(btn);

		return btn;
	}

	function initButtons() {
		let screen = App.stage;
		armageddonBtn = makeButton(Assets.ui.armageddon, 75 + 140 * 0);
		armageddonBtn.onClick.addListener(makeArmageddon);
		atomicBtn = makeButton(Assets.ui.atomic, 75 + 140 * 1);
		atomicBtn.onClick.addListener(makeAtomic);
		electroBtn = makeButton(Assets.ui.electro, 75 + 140 * 2);
		electroBtn.onClick.addListener(makeElectric);
		apocBtn = makeButton(Assets.ui.what, 75 + 140 * 3);
		apocBtn.onClick.addListener(makeApocalypse);
	}

	function initWindows() {
		shopTower = new TowerShop();
		App.stage.addChild(shopTower);
		shopRepair = new RepairShop();
		App.stage.addChild(shopRepair);
	}

	export function update(millisecondsAbsolute: number): void {
		let rabbits = Game.statBar.mobHash[DictNames.rabbit];
		checkBtn(armageddonBtn, armageddon, rabbits, millisecondsAbsolute);
		checkBtn(atomicBtn, atomic, rabbits, millisecondsAbsolute);
		checkBtn(electroBtn, electric, rabbits, millisecondsAbsolute);
		checkBtn(apocBtn, apoc, rabbits, millisecondsAbsolute);
		// armageddonBtn.setEnabled(rabbits > armageddon.price && (millisecondsAbsolute > armageddon.lastShot + armageddon.reloadTimeout));
		// atomicBtn.setEnabled(rabbits > atomic.price && (millisecondsAbsolute > atomic.lastShot + atomic.reloadTimeout));
		// electroBtn.setEnabled(rabbits > electric.price && (millisecondsAbsolute > electric.lastShot + electric.reloadTimeout));
		// apocBtn.setEnabled(rabbits > apoc.price && (millisecondsAbsolute > apoc.lastShot + apoc.reloadTimeout));

		if (uiOpened) {
			uiOpened.update();
		}
	}

	function checkBtn(btn: Button, building: Building, rabbits: number, ms: number): void {
		let achieved = rabbits > building.price;
		btn.setEnabled(achieved && (ms > building.lastShot + building.reloadTimeout));
		if (achieved) {
			let progress = (ms - building.lastShot) / building.reloadTimeout;
			progress = DnDUtils.clamp(progress, 0, 1);
			btn.setProgress(progress);
		}
	}

	let lighting: PIXI.Container;
	let lightingTime = 0.0;
	// let lightThing:

	function initLighting() {
		lighting = new PIXI.Container();
		lighting.interactiveChildren = false;

		let lightingSpr = new PIXI.Sprite(PIXI.Texture.WHITE);
		lightingSpr.width = App.screen.width;
		lightingSpr.height = App.screen.height;

		lighting.addChild(lightingSpr);
		App.stage.addChild(lighting);
	}

	export function updateLighting(delta: number) {
		if (lightingTime > 0) {
			lightingTime -= delta;
		}
		if (lightingTime < 0.01) {
			this.lightingTime = 0.0;
			lighting.visible = false;
		} else {
			lighting.visible = true;

			let mod = (lightingTime / 8.0) % 2.0;
			mod = Math.min(mod, 2.0 - mod);

			lighting.alpha = Math.sqrt(mod);
		}
	}
}